module.exports = __webpack_public_path__ + "static/img/qb8.a6ffe26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeimage/qb8.png
// module id = x0y6
// module chunks = 1